var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseMGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Right icon",
    clipPath: "url(#clip0_1298_209647)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.0002 10.5862L16.9502 5.63623L18.3642 7.05023L13.4142 12.0002L18.3642 16.9502L16.9502 18.3642L12.0002 13.4142L7.05023 18.3642L5.63623 16.9502L10.5862 12.0002L5.63623 7.05023L7.05023 5.63623L12.0002 10.5862Z",
    fill: "#686C7D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1298_209647"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseMGrey);
export default __webpack_public_path__ + "static/media/Close-m-grey.607f32f3b2d91c38383bace62b7276df.svg";
export { ForwardRef as ReactComponent };